// extracted by mini-css-extract-plugin
export default {"contentImage":"App_contentImage__wlgbh","image":"App_image__Gz0F-"};